module.exports = __webpack_public_path__ + "static/img/tab3.b37b833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCode/tab3.png
// module id = km9U
// module chunks = 0